import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams } from 'react-router-dom'
import { YStack } from 'tamagui'
import { GuildMetadata } from '@newComponents/Guild/GuildMetadata'

import { GuildMembersOrganizersSection } from './GuildMembersOrganizersSection'
import { GuildMembersEditorsSection } from '@screens/GuildMembersScreen/GuildMembersEditorsSection'
import { GuildMembersPresentersSection } from './GuildMembersPresentersSection'
import { GuildMembersNonOrganizersSection } from './GuildMembersNonOrganizersSection'

import { GuildMembersScreenQuery } from './__generated__/GuildMembersScreenQuery.graphql'

export const INITIAL_COUNTS = {
  0: 1,
  1: 1,
  2: 2,
  3: 3,
  4: 3,
}

export const GuildMembersScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<GuildMembersScreenQuery>(
    graphql`
      query GuildMembersScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name

            ...GuildMetadata_guild
            ...GuildMembersOrganizersSection_guild
            ...GuildMembersEditorsSection_guild
            ...GuildMembersPresentersSection_guild
            ...GuildMembersNonOrganizersSection_guild
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return (
    <>
      <GuildMetadata
        guild={data.nodeBySlugId}
        title={`${data.nodeBySlugId.name} Members`}
      />

      <YStack gap='$5'>
        <GuildMembersOrganizersSection guild={data.nodeBySlugId} />

        <GuildMembersEditorsSection guild={data.nodeBySlugId} />

        <GuildMembersPresentersSection guild={data.nodeBySlugId} />

        <GuildMembersNonOrganizersSection guild={data.nodeBySlugId} />
      </YStack>
    </>
  )
}

export default GuildMembersScreen
